import React, { useState } from "react";
import moment from "moment";
import './year-calendar.scss';
import {mdiChevronLeft, mdiChevronRight} from "@mdi/js";
import {Icon} from "@mdi/react";
import {DAY_OFF_CALENDAR_FORMAT, DayOffUserStore} from "./store/day-off-user-store";
import {observer} from "mobx-react";
import {assert} from "ts-essentials";
import UserAvatar from "../../components/ui/UserAvatar";
import classnames from "classnames";

type Props = { store: DayOffUserStore };

export const YearCalendar = observer((props: Props) => {
    const { store } = props;
    assert(store.daysOffForUser);

    const startOfWeek = moment.localeData().firstDayOfWeek();

    const generateCalendar = () => {
        const months = [];

        for (let i = 0; i < 12; i++) {
            const month = moment(`${store.currentYear}-${i + 1}`, 'YYYY-M');
            const totalDays = month.daysInMonth();

            const weeks = [];
            let week = Array(7)
                .fill(null)
                .map((_, index) => <div key={-index} className={'calendar-cell'}/>);

            const daysOfWeekLabels = [];
            for (let j = 0; j < 7; j++) {
                daysOfWeekLabels.push(
                    <div key={j} className={'calendar-cell week-day-title'}>
                        {moment()
                            .day((j + startOfWeek) % 7)
                            .format("dd")
                            .substring(0, 1)}
                    </div>
                );
            }

            weeks.push(daysOfWeekLabels);

            for (let j = 1; j <= totalDays; j++) {
                let day = month.clone().date(j);
                let isToday = day.isSame(moment(), "day");

                week[day.day()] = (
                    <div
                        key={j}
                        className={classnames({
                            'calendar-cell': true,
                            'is-day': true,
                            'is-today': isToday,
                            'is-day-off': store.dayOffsCached[day.format(DAY_OFF_CALENDAR_FORMAT)]
                        })}
                        onClick={() => {
                            store.openDayModal(day)
                        }}
                    >
                        {j}
                    </div>
                );

                if (day.day() === (startOfWeek + 6) % 7) {
                    weeks.push(week);
                    week = Array(7)
                        .fill(null)
                        .map((_, index) => <div key={index} className={'calendar-cell'}/>);
                }

                if (j === totalDays) {
                    weeks.push(week);
                }
            }

            months.push(
                <div key={i}>
                    <h2>{month.format("MMMM")}</h2>
                    {weeks.map((w, wi) => <div key={wi} style={{ display: "flex" }}>{w}</div>)}
                </div>
            );
        }

        return months;
    };

    return (
        <div className={'calendar-page'}>
            <div className={'calendar-header'}>
                <div className={'user-info'}>
                    <UserAvatar name={store.daysOffForUser.forUser.username} full={false}/>
                    <span className={'name'}>
                        {store.daysOffForUser.forUser.username}
                    </span>
                </div>
                <div className={'year-picker'}>
                    <button className={'button-reset'} onClick={() => store.onPreviousMonth()}>
                        <Icon path={mdiChevronLeft} size={1}/>
                    </button>
                    <span className={'year-number'}>{store.currentYear}</span>
                    <button className={'button-reset'} onClick={() => store.onNextMonth()}>
                        <Icon path={mdiChevronRight} size={1}/>
                    </button>
                </div>
            </div>
            <div className={'year-container'}>
                {generateCalendar()}
            </div>
        </div>
    );
})

